module.exports = __webpack_public_path__ + "static/media/tl5.4e2cc558.webp";